import { Button } from '@payaca/ambrosia';

import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  downloadUrl?: string;
};
const DownloadTemplateButton = ({ downloadUrl }: Props) => {
  return (
    <div className="download-button-wrapper">
      <a href={downloadUrl} target="_blank" rel="noreferrer" download>
        <Button disabled={!downloadUrl} size="sm" className="min-w-52">
          <UntitledIcon name="download-01.3" className="mr-2 h-5 w-5" />
          <span>Download template</span>
        </Button>
      </a>
    </div>
  );
};

export default DownloadTemplateButton;
